<template>
  <div class="pickupPinQR">
    <div v-if="!status?.message" class="container">
      <form>
        <Input type="text" :value="pinCode" disabled :label="$t('pinCode')" />
      </form>
      <qrcode-vue :value="pinCode" :size="250" level="H" />
    </div>
    <div v-if="status?.message" class="pickupPinQR__error">
      <div class="error" role="alert">
        {{ $t(status.message) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';
import { useRoute } from 'vue-router';

import QrcodeVue from 'qrcode.vue';

@Options({
  name: 'PickupPinQR',
  components: {
    QrcodeVue
  },
  data() {
    return {
      loading: true,
      pinCode: useRoute().query.data ? String(useRoute().query.data) : ''
    };
  },
  computed: {
    ...mapState('account', ['status'])
  }
})
export default class PickupPinQRComponent extends Vue {}
</script>

<style lang="scss" scoped>
.pickupPinQR {
  width: 100%;
  height: 100%;
  padding-top: 40px;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    form {
      width: 250px;
    }
  }
  .pickupPinQR__error {
    .error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: $sixteenSize;
      line-height: $eighteenSize;
      font-weight: 400;
      color: $messageError;
    }
  }
}
</style>
